<terra-search-input
  placeholder="Search Teams..."
  [ngModel]="_searchTerm"
  (ngModelChange)="onSearchChange($event)"
  (cleared)="clearSearch()" />
